/**
 * Route for `four-payout-types-default-campaign-publisher-speci`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FourPayoutTypesDefaultCampaignPublisherSpeciPage } from "../features/four-payout-types-default-campaign-publisher-speci/FourPayoutTypesDefaultCampaignPublisherSpeciPage";

export const fourPayoutTypesDefaultCampaignPublisherSpeciRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/four-payout-types-default-campaign-publisher-speci",
	component: FourPayoutTypesDefaultCampaignPublisherSpeciPage,
});

export default fourPayoutTypesDefaultCampaignPublisherSpeciRoute;
